/* Massimo collection pricing.
 *
 * Collection/search cards must not show Shopify's 0.00 TL variant price.
 * They show the live Massimo API total for a fixed 100x200 rectangle with
 * biye edge, resolved per product through massimo-ozel-olcu-config.js.
 */
(function () {
  'use strict';

  if (window.__MASSIMO_COLLECTION_PRICING__) return;
  window.__MASSIMO_COLLECTION_PRICING__ = true;

  var BUILD = 'massimo-collection-pricing-v7-100x200-biye-money-only-clean';
  var FIXED_WIDTH = 100;
  var FIXED_LENGTH = 200;
  var FIXED_EDGE = 'biye';
  var FIXED_SHAPE = 'dikdortgen';
  var SCRIPT_SRC = (document.currentScript && document.currentScript.src) || '';

  var API_BASE = window.__MASSIMO_API_BASE__
    || (window.__MASSIMO_ALL_CONFIGS__ && window.__MASSIMO_ALL_CONFIGS__.massimoApi)
    || 'https://dolcevita-massimo.ngrok.io/api/massimo';

  var QUALITY_ALIAS = {
    barcelona: 'barceleno',
    bounty: 'cordoba'
  };

  var PRODUCT_HANDLE_RE = /\/products\/([^/?#]+)/i;
  var MASSIMO_HANDLE_RE = /^massimo-(?:carpet-)?([a-z0-9]+)-(\d+)(?:-[a-z0-9-]+)?$/i;

  var configPromise = null;
  var fixedPriceCache = {};
  var inFlight = {};

  function fmtTRY(value) {
    var n = Number(value);
    if (!isFinite(n)) return null;
    try {
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(n) + ' TL';
    } catch (_) {
      return n.toFixed(2) + ' TL';
    }
  }

  function assetConfigUrl() {
    var existingTag = document.querySelector('script[src*="massimo-ozel-olcu-config"]');
    if (existingTag && existingTag.src) return existingTag.src;

    var src = SCRIPT_SRC;
    if (!src) {
      var pricingTag = document.querySelector('script[src*="massimo-collection-pricing"]');
      if (pricingTag && pricingTag.src) src = pricingTag.src;
    }
    if (!src) {
      var renderTag = document.querySelector('script[src*="massimo-collection-render"]');
      if (renderTag && renderTag.src) src = renderTag.src;
    }
    if (!src) {
      var anyAsset = document.querySelector('script[src*="/cdn/shop/t/"][src*="/assets/"]');
      if (anyAsset && anyAsset.src) src = anyAsset.src;
    }
    if (!src) return '';

    return src.replace(/assets\/[^/?#]+/, 'assets/massimo-ozel-olcu-config.js');
  }

  function loadConfig() {
    if (configPromise) return configPromise;
    if (window.__MASSIMO_ALL_CONFIGS__) {
      configPromise = Promise.resolve(window.__MASSIMO_ALL_CONFIGS__);
      return configPromise;
    }

    var src = assetConfigUrl();
    if (!src) {
      configPromise = Promise.reject(new Error('config_url_missing'));
      return configPromise;
    }

    configPromise = new Promise(function (resolve, reject) {
      var done = false;
      var to = setTimeout(function () {
        if (done) return;
        done = true;
        reject(new Error('config_timeout'));
      }, 8000);

      function finish(err) {
        if (done) return;
        done = true;
        clearTimeout(to);
        if (err) reject(err);
        else if (window.__MASSIMO_ALL_CONFIGS__) resolve(window.__MASSIMO_ALL_CONFIGS__);
        else reject(new Error('config_loaded_without_global'));
      }

      var s = document.createElement('script');
      s.src = src;
      s.onload = function () { finish(null); };
      s.onerror = function () { finish(new Error('config_script_error')); };
      document.head.appendChild(s);
    });

    return configPromise;
  }

  function parseCard(link) {
    var href = link && (link.getAttribute('href') || link.href || '');
    var hm = href.match(PRODUCT_HANDLE_RE);
    if (!hm) return null;

    var handle = hm[1];
    var mm = handle.match(MASSIMO_HANDLE_RE);
    if (!mm) return null;

    return {
      handle: handle,
      quality: mm[1].toLowerCase(),
      pattern: mm[2],
      link: link
    };
  }

  function matchesConfiguredHandle(productCfg, handle) {
    if (!productCfg || !handle) return false;
    if (productCfg.productHandle === handle || productCfg.shopifyHandle === handle) return true;

    var handles = productCfg.shopifyHandles || {};
    for (var edgeType in handles) {
      if (Object.prototype.hasOwnProperty.call(handles, edgeType) && handles[edgeType] === handle) {
        return true;
      }
    }
    return false;
  }

  function findProductConfigByHandle(config, handle) {
    var products = (config && config.products) || {};
    for (var key in products) {
      if (Object.prototype.hasOwnProperty.call(products, key) && matchesConfiguredHandle(products[key], handle)) {
        return products[key];
      }
    }
    return null;
  }

  function resolveProductInfo(parsed, config) {
    var products = (config && config.products) || {};
    var aliasQuality = QUALITY_ALIAS[parsed.quality] || parsed.quality;
    var productCfg = products[parsed.quality + '-' + parsed.pattern]
      || products[aliasQuality + '-' + parsed.pattern]
      || products[parsed.handle]
      || findProductConfigByHandle(config, parsed.handle);

    return {
      handle: parsed.handle,
      quality: (productCfg && productCfg.qualityCode) || aliasQuality,
      pattern: (productCfg && productCfg.patternCode) || parsed.pattern,
      configKey: productCfg && (productCfg.key || productCfg.configKey || '')
    };
  }

  function findCardRoot(link) {
    var node = link;
    for (var i = 0; i < 8 && node; i++) {
      node = node.parentElement;
      if (!node) return null;
      if (!node.querySelector) continue;
      if (
        node.querySelector('img') &&
        node.querySelector('a[href*="/products/massimo-"]') &&
        node.querySelector('.hdt-price, .hdt-price-wrapp, [class*="price"]')
      ) {
        return node;
      }
    }
    return null;
  }

  function isUsablePriceElement(el) {
    if (!el || !el.textContent) return false;
    if (el.closest && el.closest('script,style,template,button,label')) return false;
    return true;
  }

  function findPriceElement(cardRoot) {
    var selectors = [
      '.hdt-price .money',
      '.hdt-price [class*="money"]',
      '.hdt-price',
      '.hdt-price-wrapp',
      '[class*="price"]:not(button):not(label)'
    ];

    for (var s = 0; s < selectors.length; s++) {
      var candidates = cardRoot.querySelectorAll(selectors[s]);
      for (var i = 0; i < candidates.length; i++) {
        if (isUsablePriceElement(candidates[i])) return candidates[i];
      }
    }
    return null;
  }

  function extractTotalPrice(data) {
    var pricing = (data && data.pricing) || {};
    var candidates = [
      pricing.total,
      pricing.totalPrice,
      pricing.finalTotal,
      pricing.finalPrice,
      data && data.total,
      data && data.price
    ];

    for (var i = 0; i < candidates.length; i++) {
      var n = Number(candidates[i]);
      if (isFinite(n) && n > 0) return n;
    }
    return null;
  }

  function fetchFixedCardPrice(product) {
    var key = product.quality + '|' + product.pattern + '|' + FIXED_WIDTH + 'x' + FIXED_LENGTH + '|' + FIXED_EDGE;
    if (Object.prototype.hasOwnProperty.call(fixedPriceCache, key)) {
      return Promise.resolve(fixedPriceCache[key]);
    }
    if (inFlight[key]) return inFlight[key];

    var url = API_BASE.replace(/\/+$/, '') + '/storefront-price'
      + '?quality=' + encodeURIComponent(product.quality)
      + '&pattern=' + encodeURIComponent(product.pattern)
      + '&width=' + encodeURIComponent(FIXED_WIDTH)
      + '&length=' + encodeURIComponent(FIXED_LENGTH)
      + '&edgeType=' + encodeURIComponent(FIXED_EDGE)
      + '&shapeType=' + encodeURIComponent(FIXED_SHAPE);

    var p = fetch(url, { credentials: 'omit', mode: 'cors' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data || data.ok === false) {
          throw new Error((data && (data.error || data.message)) || 'invalid_response');
        }

        var total = extractTotalPrice(data);
        if (!total) throw new Error('total_price_missing');

        var result = {
          total: total,
          currency: data.currency || 'TRY',
          priceListName: data.priceListName || '',
          quality: product.quality,
          pattern: product.pattern
        };
        fixedPriceCache[key] = result;
        delete inFlight[key];
        return result;
      })
      .catch(function (err) {
        delete inFlight[key];
        console.warn('[massimo-collection-pricing] fixed price failed:', product.handle, product.quality, product.pattern, err.message || err);
        throw err;
      });

    inFlight[key] = p;
    return p;
  }

  function hideElement(el) {
    if (!el || !el.setAttribute) return;
    el.setAttribute('hidden', 'hidden');
    el.setAttribute('aria-hidden', 'true');
    el.style.setProperty('display', 'none', 'important');
  }

  function cleanFakeDiscounts(cardRoot, priceEl) {
    if (!cardRoot || !cardRoot.querySelectorAll) return;

    var compareSelectors = [
      'hdt-compare-at-price',
      '.hdt-compare-at-price',
      '.hdt-price__compare',
      '.hdt-compare-price',
      '.compare-at-price',
      '.price__compare',
      's',
      'del'
    ];
    compareSelectors.forEach(function (selector) {
      Array.prototype.forEach.call(cardRoot.querySelectorAll(selector), function (el) {
        if (priceEl && (el === priceEl || (el.contains && el.contains(priceEl)))) return;
        hideElement(el);
      });
    });

    var badgeSelectors = [
      '.dolcevita-discount-badge',
      '.hdt-badge__on-sale',
      'hdt-badge.hdt-badge__on-sale',
      '.hdt-badge--sale',
      '.hdt-badge__sale',
      '[class*="discount"][class*="badge"]',
      '[class*="badge"][class*="sale"]'
    ];
    badgeSelectors.forEach(function (selector) {
      Array.prototype.forEach.call(cardRoot.querySelectorAll(selector), hideElement);
    });
  }

  function setCardPriceText(priceEl, displayText, state, product) {
    if (!priceEl) return;

    priceEl.setAttribute('data-massimo-pricing-build', BUILD);
    priceEl.setAttribute('data-massimo-pricing-applied', '1');
    priceEl.setAttribute('data-massimo-pricing-width', String(FIXED_WIDTH));
    priceEl.setAttribute('data-massimo-pricing-length', String(FIXED_LENGTH));
    priceEl.setAttribute('data-massimo-pricing-edge', FIXED_EDGE);

    if (product) {
      priceEl.setAttribute('data-massimo-pricing-quality', product.quality || '');
      priceEl.setAttribute('data-massimo-pricing-pattern', product.pattern || '');
    }

    if (state === 'error') {
      priceEl.classList.add('massimo-card-price--error');
      priceEl.classList.remove('massimo-card-price--fixed');
      priceEl.textContent = displayText;
      return;
    }

    priceEl.classList.add('massimo-card-price--fixed');
    priceEl.classList.remove('massimo-card-price--error');
    priceEl.textContent = displayText;
  }

  function processCardsWithConfig(config) {
    var links = Array.from(document.querySelectorAll('a[href*="/products/massimo-"]'));
    var queued = {};

    links.forEach(function (link) {
      var parsed = parseCard(link);
      if (!parsed) return;

      var cardRoot = findCardRoot(link);
      if (!cardRoot) return;
      if (cardRoot.getAttribute('data-massimo-pricing-build') === BUILD) {
        cleanFakeDiscounts(cardRoot, findPriceElement(cardRoot));
        return;
      }

      var priceEl = findPriceElement(cardRoot);
      if (!priceEl) return;
      if (
        priceEl.getAttribute('data-massimo-pricing-applied') === '1' &&
        priceEl.getAttribute('data-massimo-pricing-build') === BUILD
      ) {
        cleanFakeDiscounts(cardRoot, priceEl);
        return;
      }

      var queueKey = parsed.handle + '|' + Array.prototype.indexOf.call(document.querySelectorAll('.hdt-price, .hdt-price-wrapp, [class*="price"]'), priceEl);
      if (queued[queueKey]) return;
      queued[queueKey] = true;

      var product = resolveProductInfo(parsed, config);
      cardRoot.setAttribute('data-massimo-pricing-build', BUILD);

      fetchFixedCardPrice(product).then(function (priceData) {
        var money = fmtTRY(priceData.total);
        if (!money) throw new Error('format_failed');
        setCardPriceText(priceEl, money, 'ok', product);
        cleanFakeDiscounts(cardRoot, priceEl);
      }).catch(function () {
        cardRoot.removeAttribute('data-massimo-pricing-build');
        setCardPriceText(priceEl, 'Fiyat alinamadi', 'error', product);
        cleanFakeDiscounts(cardRoot, priceEl);
      });
    });
  }

  function processCards() {
    loadConfig()
      .catch(function (err) {
        console.warn('[massimo-collection-pricing] config not loaded, parsed handles will be used:', err.message || err);
        return null;
      })
      .then(processCardsWithConfig);
  }

  function ensureStyles() {
    if (document.getElementById('massimo-collection-pricing-styles')) return;

    var css = ''
      + '.massimo-card-price--fixed{color:#8f5f34;font-weight:650}'
      + '.massimo-card-price--error{color:#a83232;font-size:11px;font-weight:500}';

    var styleEl = document.createElement('style');
    styleEl.id = 'massimo-collection-pricing-styles';
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  }

  function isCollectionLike() {
    var path = (window.location.pathname || '').toLowerCase();
    if (/^\/products\//.test(path)) return false;
    return true;
  }

  function init() {
    if (!isCollectionLike()) return;
    ensureStyles();
    processCards();

    var debounce;
    var observer = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(processCards, 250);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
